import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import DetailPageHeader from '../../pages/markets/component/detail-page-header';
import FuturesExternalSearch from '../../pages/markets/component/futures-external-search';
import MostActiveTableFuturesExternal from '../../pages/markets/component/most-active-table-futures-external';
import '../../pages/markets/pages/futures-external-most-active-contracts/futures-external-most-active-contracts.m.css';

const MostActiveContractsFull = () => {
  const queryClient = new QueryClient();
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        {initialLoading ? (
          <div styleName="initial-loading-container"></div>
        ) : (
          <div styleName="detail-header-container">
            <div className="container">
              <DetailPageHeader />
            </div>
          </div>
        )}

        <div styleName="overall-container">
          <div styleName="search-widget-container" className="container">
            <FuturesExternalSearch />

            <MostActiveTableFuturesExternal limit={200} external={true} />
          </div>
        </div>
        <div className="container">
          <FuturesAndOptionsFaq />
        </div>
      </>
    </QueryClientProvider>
  );
};

export default MostActiveContractsFull;
